/* eslint-disable react/prop-types */
import classes from "./geographilcal-area.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import SelectableList from "@/components-library/widgets/selectable-list";
import Switch from "@/components-library/widgets/switch";
function GeographicalArea({
  selectedRegion,
  selectedCities,
  regions,
  cities,
  onCitySelect,
  onRegionSelect,
  isRegionValid,
  isCityValid,
  isNational,
  onNationalSelcet,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Area geografica
      </Label>

      <Switch
        isChecked={isNational}
        onChange={onNationalSelcet}
        isEnabled={true}
        labelOn="Nazionale"
        className={classes.switch}
      />
      <Grid columns="1fr 1fr">
        <SelectableList
          title="Regione*"
          list={regions}
          value={selectedRegion}
          onItemSelect={onRegionSelect}
          isEnabled={!isNational}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isRegionValid,
          })}
          titleClassName={classes.titleList}
        />
        <SelectableList
          title="Provincia*"
          list={cities}
          value={selectedCities}
          onItemSelect={onCitySelect}
          isEnabled={!isNational}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isCityValid,
          })}
          titleClassName={classes.titleList}
        />
      </Grid>
    </Flex>
  );
}

export default GeographicalArea;
